import { render, staticRenderFns } from "./Relative.vue?vue&type=template&id=0bc3da5a"
import script from "./Relative.vue?vue&type=script&lang=js"
export * from "./Relative.vue?vue&type=script&lang=js"
import style0 from "./Relative.vue?vue&type=style&index=0&id=0bc3da5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports